module.exports = __webpack_public_path__ + "static/notice-dismiss-do-fb01c1d2c4b1c17540e9799342ad9bba.png";